import Vue from 'vue'
import Cookies from 'js-cookie'

Vue.prototype.$cookies = Cookies
